const validForFlag = {
  Unset: 0,
  RemedioProvisional: 1,
  Therapy: 2,
  Pei: 3,
  PeiOther: 4,
  Appointment: 5,
  Triannual: 6,
  Registry: 7,
  RegistryEligibility: 8,
};

export default validForFlag;
